import palette from '../../../styled-components/palette';
import { PartialDeep } from '../../../utils/typing';
import { GRSkinId, GRSkinIds } from '../types/global';

const defaultUI = {
  Informations: {
    primaryColor: palette.yellowwinamax300,
    secondaryColor: '#cf63cf',
    defaultColor: palette.white,
  },
};

const GRUIBySkinId = new Proxy<Record<GRSkinId, PartialDeep<typeof defaultUI>>>(
  {
    [GRSkinIds.GIFT_RACE]: defaultUI,
    [GRSkinIds.HUNTING_ALL_STARS]: {
      ...defaultUI,
      Informations: {
        ...defaultUI.Informations,
        primaryColor: palette.yellowwinamax300,
        secondaryColor: palette.yellowwinamax300,
      },
    },
  },
  {
    get(origin, key: GRSkinId) {
      if (!origin[key]) {
        return defaultUI;
      }

      return origin[key];
    },
  },
);

export default GRUIBySkinId;
